import styled from 'styled-components'

export default StyledComponent => styled(StyledComponent)`
  cursor: pointer;
  outline: none;
`
